/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Elementos',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Actualizado',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'Novedad',
  'company-hub.hub-element-placeholder.extension.sub-heading': 'Aún no hay nada aquí. Piensa en las posibilidades...',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'Ver todas las opciones',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Marcador de posición del elemento central',
};
